import { useFormContext } from "react-hook-form";

import {
  CrossPartnerMarketingOptInAdult,
  PartnerPPAccept,
  StudentAddressCountry,
  StudentAddressCountryName,
  StudentAddressState,
  StudentEmail,
  StudentFirstName,
  StudentLastName,
  StudentMiddleName,
  UnderAgeMarketingConsent,
} from "@up/application-fields";

import type { GeoData } from "@up/data";
import type { ReactNode } from "react";

export function StudentInformationPage1Adult({
  bottom,
  geo,
}: {
  bottom: () => ReactNode;
  geo: GeoData;
}) {
  const { watch } = useFormContext();

  const studentSelectedCountry = watch(StudentAddressCountryName);

  const SHOW_CROSS_PARTNER_MARKETING_OPT_IN =
    geo.isDomestic || studentSelectedCountry === "United States";
  const SHOW_UNDER_AGE_MARKETING_CONSENT =
    geo.isIntl || studentSelectedCountry !== "United States";

  return (
    <>
      <div className="grid-cols-3 gap-4 md:grid">
        <StudentFirstName label="First Name" />

        <StudentMiddleName label="Middle Name" />

        <StudentLastName label="Last Name" />
      </div>

      <div className="md:grid-cols-3 md:gap-4 gap-6 grid mb-6">
        <div className="col-span-2">
          <StudentAddressCountry label="Country of Residence" />
        </div>
        {studentSelectedCountry === "United States" && (
          <StudentAddressState label="State of Residence" />
        )}
      </div>

      <StudentEmail />

      <div
        className={`${SHOW_UNDER_AGE_MARKETING_CONSENT || SHOW_CROSS_PARTNER_MARKETING_OPT_IN ? "kup-fieldset" : ""}`}
      >
        {SHOW_UNDER_AGE_MARKETING_CONSENT && <UnderAgeMarketingConsent />}
        {SHOW_CROSS_PARTNER_MARKETING_OPT_IN ? (
          <CrossPartnerMarketingOptInAdult />
        ) : null}
      </div>

      <PartnerPPAccept isDomestic={geo.isDomestic} />

      {bottom()}
    </>
  );
}
